// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailSendEmailSingle {
    static getAttributeTypeMap() {
        return EmailSendEmailSingle.attributeTypeMap;
    }
}
EmailSendEmailSingle.discriminator = undefined;
EmailSendEmailSingle.attributeTypeMap = [
    {
        "name": "contact",
        "baseName": "contact",
        "type": "EmailEmailContact"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "parameters",
        "baseName": "parameters",
        "type": "string"
    },
    {
        "name": "fromName",
        "baseName": "fromName",
        "type": "string"
    },
    {
        "name": "fromAddress",
        "baseName": "fromAddress",
        "type": "string"
    },
    {
        "name": "emailName",
        "baseName": "emailName",
        "type": "string"
    },
    {
        "name": "tag",
        "baseName": "tag",
        "type": "string"
    },
    {
        "name": "deliveryType",
        "baseName": "deliveryType",
        "type": "string"
    },
    {
        "name": "messageContentType",
        "baseName": "messageContentType",
        "type": "MessageContentType"
    }
];
//# sourceMappingURL=emailSendEmailSingle.js.map